export default class Errors {
  constructor() {
    this.errors = {};
  }

  set(errors) {
    // avoid setting errors to undefined or null
    if (errors) {
      this.errors = errors;
    }
  }

  all() {
    return this.errors;
  }

  has(field) {
    return Object.prototype.hasOwnProperty.call(this.errors, field);
  }

  hasAny(...fields) {
    return fields.some(field => this.has(field));
  }

  any() {
    return Object.keys(this.errors).length > 0;
  }

  get(field) {
    if (this.has(field)) {
      return this.errors[field];
    }

    return null;
  }

  getString(field) {
    if (this.has(field)) {
      const messages = this.errors[field];

      return Array.isArray(messages) ? messages.join(', ') : messages;
    }
  }

  only(...fields) {
    const messages = [];

    fields.forEach(field => {
      const message = this.get(field);

      if (message) {
        messages.push(message);
      }
    });

    return messages;
  }

  except(fields) {
    // array
    let keys = Object.keys(this.errors);

    return keys
      .map(key => {
        if (!fields.includes(key)) {
          return this.errors[key];
        }

        return null;
      })
      .filter(val => val);
  }

  flatten() {
    let error_values = Object.keys(this.errors).map(key => {
      return this.errors[key];
    });

    return error_values.reduce((a, b) => a.concat(b), []);
  }

  clear(field) {
    if (field) {
      delete this.errors[field];
      return;
    }

    this.errors = {};
  }
}
